module.exports = __webpack_public_path__ + "static/media/first_place_session.febae0ab.png";